import _isObject from "../internals/is-object";
import _createNonEnumerableProperty from "../internals/create-non-enumerable-property";
var exports = {};
var isObject = _isObject;
var createNonEnumerableProperty = _createNonEnumerableProperty;

// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
exports = function (O, options) {
  if (isObject(options) && "cause" in options) {
    createNonEnumerableProperty(O, "cause", options.cause);
  }
};
export default exports;